import { Types as AppTypes } from '../../actions/app'
import { Types as ContentTypes } from '../../actions/content'
import initialState, { initialForm } from './initialState'
import channelsReducer from './channels'
import layersReducer from './layers'
import mediaReducer from './media'
import playlistsReducer from './playlists'
import uploadsReducer from './uploads'

export default (state = initialState, { type, payload = {}, meta = {} }) => {
    // Channels reducer
    const channelState = channelsReducer(state, { type, payload, meta })

    if (channelState) {
        return channelState
    }

    // Layers Reducer
    const layerState = layersReducer(state, { type, payload, meta })

    if (layerState) {
        return layerState
    }

    // Media reducer
    const mediaState = mediaReducer(state, { type, payload, meta })

    if (mediaState) {
        return mediaState
    }

    // Playlists reducer
    const playlistsState = playlistsReducer(state, { type, payload, meta })

    if (playlistsState) {
        return playlistsState
    }

    // Uploads reducer
    const uploadsState = uploadsReducer(state, { type, payload, meta })

    if (uploadsState) {
        return uploadsState
    }

    switch (type) {
        case 'persist/REHYDRATE':
            const { app: lastState = {} } = payload
            return {
                ...initialState,
                ...lastState,
                selected: {
                    ...initialState.selected,
                },
            }
        case AppTypes.SELECT_ESTATE: {
            return {
                ...state,
                ...initialState,
            }
        }
        case ContentTypes.EDIT_CONTENT_FORM: {
            const { contentType } = meta
            return {
                ...state,
                form: {
                    ...state.form,
                    [contentType]: payload,
                },
            }
        }
        case ContentTypes.EDIT_CONTENT_FORM_VALUE: {
            const { name, value } = payload
            const { contentType } = meta
            return {
                ...state,
                form: {
                    ...state.form,
                    [contentType]: {
                        ...state.form[contentType],
                        [name]: value,
                    },
                },
            }
        }
        case ContentTypes.RESET_FORM: {
            const { contentType } = meta

            // If contentType not defined
            if (!contentType) {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        ...initialForm,
                    },
                }
            }

            return {
                ...state,
                form: {
                    ...state.form,
                    [contentType]: { ...initialForm[contentType] },
                },
            }
        }
        case ContentTypes.RESET_UPLOAD: {
            const { contentType } = meta

            // If contentType not defined
            if (!contentType) {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        ...initialForm,
                    },
                    uploaded: [],
                }
            }

            return {
                ...state,
                form: {
                    ...state.form,
                    [contentType]: { ...initialForm[contentType] },
                },
                uploaded: [],
            }
        }
        default:
            return state
    }
}
